import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
  Alert,
} from "reactstrap";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import caspLogo from "../../assets/images/casp-main-logo.png"
import GoogleLogo from "../../assets/images/Google_Logo.png";
import MicroSoftLogo from "../../assets/images/Microsoft_logo.png"
import stageLogo from '../../assets/images/KVP-logo1.svg';
import devLogo from '../../assets/images/PST-logo.png';

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

//Social Media Imports
// import { GoogleLogin } from "react-google-login";
// import TwitterLogin from "react-twitter-auth"
// import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
// actions
import { loginUser, socialLogin, resetLoginFlag } from "../../store/actions";

// import logoLight from "../../assets/images/logo-light.png";
import logoLight from "../../assets/images/R&D logo.svg";
import kacsLogo from "../../assets/images/kacs-logo.png";
//Import config
import { facebook, google } from "../../config";

import withRouter from "../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";
import LanguageDropdown from "../../Components/Common/LanguageDropdown";

const Login = (props) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => ({
    user: state.Account.user,
  }));

  const [userLogin, setUserLogin] = useState([]);
  const [showpass, setshowpass] = useState(false);
  const matchStageEnv = /\bstage\b/i;
  useEffect(() => {
    if (user && user) {
      setUserLogin({
        email: user.user.email,
        password: user.user.confirm_password,
      });
    }
  }, [user]);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: userLogin.email || "",
      password: userLogin.password || "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .strict(true)
        .trim(props.t('Must not include leading and trailing spaces'))
        .required(props.t("Please Enter Your Email")),
      password: Yup.string()
        .strict(true)
        .trim(props.t('Must not include leading and trailing spaces'))
        .required(props.t("Please Enter Your Password")),
    }),
    onSubmit: (values) => {
      dispatch(loginUser(values, props.router.navigate));
    },
  });

  const { error } = useSelector((state) => ({
    error: state.Login.error,
  }));

  const signIn = (res, type) => {
    if (type === "google" && res) {
      const postData = {
        name: res.profileObj.name,
        email: res.profileObj.email,
        token: res.tokenObj.access_token,
        idToken: res.tokenId,
      };
      dispatch(socialLogin(postData, props.router.navigate, type));
    } else if (type === "facebook" && res) {
      const postData = {
        name: res.name,
        email: res.email,
        token: res.accessToken,
        idToken: res.tokenId,
      };
      dispatch(socialLogin(postData, props.router.navigate, type));
    }
  };

  //handleGoogleLoginResponse
  const googleResponse = (response) => {
    signIn(response, "google");
  };

  //handleTwitterLoginResponse
  // const twitterResponse = e => {}

  //handleFacebookLoginResponse
  const facebookResponse = (response) => {
    signIn(response, "facebook");
  };

  const hideShowPass = () => {
    // console.log("gyyy")
    setshowpass(!showpass)
    // console.log(showpass)
  }

  useEffect(() => {
    setTimeout(() => {
      dispatch(resetLoginFlag());
    }, 3000);
  }, [dispatch, error]);

  document.title = props.t("SignIn ");
  return (
    <React.Fragment>
      <div style={{ float: "right", marginRight: "20px" }}>
        <LanguageDropdown />
      </div>
      <div
        className="login-bgImg d-flex justify-content-center align-items-center w-100 h-screen"
        // style={{ width: "100%", height: "100vh" }}
      >
        <div className="auth-page-content login-new-pg w-100">
          {/* <Container>
            <Row className="justify-content-center mt-3">
              <Col md={8} lg={6}> */}
          <Card style={{ width: '500px', margin: '0 auto' }}>
            <CardBody className="p-4">
              <Row>
                <Col lg={12}>
                  <div className="text-center text-white-50">
                    <Link to="/" className=" auth-logo">
                      {/* <img src={caspLogo} alt="" height="50" /> */}
                      <img src={stageLogo} alt="Logo" className="logo_size" />
                    </Link>
                  </div>
                </Col>
              </Row>
              <div className="text-center mt-2">
                <h5 className="mt-4">{props.t("Please Login To Continue")}</h5>
                {/* <p className="text-muted">
                        Sign in to continue to Velzon.
                      </p> */}
              </div>
              {error && error ? (
                <Alert color="danger"> {error} </Alert>
              ) : null}
              <div className="p-2 mt-4">
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                  action="#"
                >
                  <div className="mb-3">
                    {/* <Label htmlFor="email" className="form-label">
                            Username
                          </Label> */}
                    <Input
                      name="email"
                      className="form-control py-2"
                      placeholder={props.t("Email ID")}
                      type="email"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.email || ""}
                      invalid={
                        validation.touched.email &&
                          validation.errors.email
                          ? true
                          : false
                      }
                    />
                    {validation.touched.email &&
                      validation.errors.email ? (
                      <FormFeedback type="invalid">
                        {validation.errors.email}
                      </FormFeedback>
                    ) : null}
                  </div>

                  <div className="mb-3">
                    {/* <div className="float-end">
                            <Link to="/forgot-password" className="text-muted">
                              Forgot password?
                            </Link>
                          </div> */}
                    {/* <Label
                            className="form-label"
                            htmlFor="password-input"
                          >
                            Password
                          </Label> */}
                    <div className="position-relative auth-pass-inputgroup mb-3">
                      <Input
                        name="password"
                        value={validation.values.password || ""}
                        type={showpass ? "text" : "password"}
                        className="form-control pe-5 py-2"
                        placeholder={props.t("Password")}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        invalid={
                          validation.touched.password &&
                            validation.errors.password
                            ? true
                            : false
                        }
                      />
                      {validation.touched.password &&
                        validation.errors.password ? (
                        <FormFeedback type="invalid">
                          {validation.errors.password}
                        </FormFeedback>
                      ) : null}
                      <button
                        onClick={hideShowPass}
                        className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                        type="button"
                        id="password-addon"
                      >
                        <i
                          className={
                            showpass == false
                              ? "ri-eye-fill align-middle"
                              : "ri-eye-off-fill"
                          }
                        ></i>
                      </button>
                    </div>
                  </div>

                  <div className="form-check p-0">
                    {/* <Input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="auth-remember-check"
                          /> */}
                    <Link to="/forgot-password" className="link_color form-check-label">
                      {props.t("Forgot password?")}
                    </Link>
                  </div>

                  <div className="mt-4">
                    <Button
                      // color="#206DF1"
                      className="btn w-100 main-login-btn"
                      type="submit"
                    >
                      {props.t("Login")}
                    </Button>
                  </div>

                  {/*<div className="mt-4">
                           <div className="text-center">
                            <p className="mb-0 position-relative alternate_loginOption">
                              Or Login With
                            </p>
                          </div>

                          <div className="my-4">
                            <Container>
                              <Row className="g-3">
                                <Col lg={6}>
                                  <div
                                    className="d-flex justify-content-center align-items-center p-2 rounded-1 external_loginBtn"

                                  >
                                    <img src={GoogleLogo} alt="" />
                                    <span className="mb-0 ms-3 fs-16">
                                      Google Account
                                    </span>
                                  </div>
                                </Col>
                                <Col lg={6}>
                                  <div
                                    className="d-flex justify-content-center align-items-center py-2 px-1 rounded-1 external_loginBtn"

                                  >
                                    <img src={MicroSoftLogo} alt="" />
                                    <span className="mb-0 ms-3 fs-16">
                                      Microsoft Account
                                    </span>
                                  </div>
                                </Col>
                              </Row>
                            </Container>
                          </div> */}
                  {/* <div className="text-center">
                            <p className="new-login-grey-text">
                              New user?
                              <a href="#" className="ms-1 link_color">
                                Sign up
                              </a>
                            </p>
                          </div>
                        </div>*/}

                  {/* <div className="mt-4 text-center">
                                                    <div className="signin-other-title">
                                                        <h5 className="fs-13 mb-4 title">Sign In with</h5>
                                                    </div>
                                                    <div>
                                                        <FacebookLogin
                                                            appId={facebook.APP_ID}
                                                            autoLoad={false}
                                                            callback={facebookResponse}
                                                            render={renderProps => (
                                                                <Button color="primary"
                                                                    className="btn-icon me-1"
                                                                    onClick={renderProps.onClick}
                                                                >
                                                                    <i className="ri-facebook-fill fs-16" />
                                                                </Button>
                                                            )}
                                                        />
                                                        <GoogleLogin
                                                            clientId={
                                                                google.CLIENT_ID ? google.CLIENT_ID : ""
                                                            }
                                                            render={renderProps => (
                                                                <Button color="danger"
                                                                    to="#"
                                                                    className="btn-icon me-1"
                                                                    onClick={renderProps.onClick}
                                                                >
                                                                    <i className="ri-google-fill fs-16" />
                                                                </Button>
                                                            )}
                                                            onSuccess={googleResponse}
                                                            onFailure={(error) => {
                                                            }}
                                                        />
                                                        <Button color="dark" className="btn-icon"><i className="ri-github-fill fs-16"></i></Button>{" "}
                                                        <Button color="info" className="btn-icon"><i className="ri-twitter-fill fs-16"></i></Button>
                                                    </div>
                                                </div> */}
                </Form>
              </div>
            </CardBody>
          </Card>

          {/* <div className="mt-4 text-center">
                                    <p className="mb-0">Don't have an account ? <Link to="/register" className="fw-semibold text-primary text-decoration-underline"> Signup </Link> </p>
                                </div> */}
          {/* </Col>
            </Row>
          </Container> */}
        </div>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(withRouter(Login));
